import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import Checkbox from '../../../../shared/checkbox';
import useFeatureWireStore from './state-hooks';

const Container = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 12px 16px;
  width: 100%;

  &.has-border {
    border: 1px solid #D7DFE7;
  }

  &:hover {
    cursor: pointer;
  }
`;

const Primary = styled.div`
  display: flex;
  flex-direction: column;
`;

const Type = styled.div`
  color: ${props => props.theme.primaryColor};
  font-size: 11px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 2px;
`;

const Name = styled.div`
  font-size: 14px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 2px;
`;

const Company = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-size: 14px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  line-height: 16px;
`;

export default function Option({ featureable, border }) {
  const {
    name,
    company,
    type,
  } = featureable;

  const set = useFeatureWireStore(state => state.set);
  const selected = useFeatureWireStore(state => state.selectedFeatureable);
  const isSelected = !!_.find(selected, featureable);

  const toggleSelection = e => {
    e && e.preventDefault();

    let newSelected;

    if (isSelected) {
      const index = _.findIndex(selected, featureable);
      newSelected = [
        ..._.take(selected, index),
        ..._.takeRight(selected, selected.length - index - 1),
      ];
    } else {
      newSelected = [...selected, featureable];
    }

    set(state => {
      state.selectedFeatureable = newSelected;
    });
  };

  return (
    <Container className={border ? 'has-border' : ''} onClick={toggleSelection}>
      <Primary>
        <Type>{type}</Type>
        <Name>{name}</Name>
        <Company>{company}</Company>
      </Primary>
      <Checkbox className={classNames('fa fa-border', { 'fa-check': isSelected })} />
    </Container>
  );
}

Option.propTypes = {
  featureable: PropTypes.shape({
    name: PropTypes.string.isRequired,
    company: PropTypes.string,
    type: PropTypes.string.isRequired,
  }).isRequired,
  border: PropTypes.bool,
};

Option.defaultProps = {
  border: false,
};
